import { ref } from "vue";
import { defineStore } from "pinia";

/**
 * Progress Store
 * Manages the overall progress of the participant through the whole questionnaire, including:
 * - Welcome page
 * - Criteria page
 * - Each section of the questionnaire
 * - ...
 * - Conclusion page
 *
 * The store tracks:
 * - Overall progress percentage (0-100)
 * - Progress within the current section
 * - Visibility of the progress indicator
 */
export const useProgressStore = defineStore("progress", () => {
  const progress_percentage = ref(0);
  const current_section_progress = ref(null);
  const visible = ref(false);

  // Overall progress percentage (0-100)
  const setProgressPercentage = (progress) => {
    const rawPercentage = progress?.progress_percentage || 0;
    progress_percentage.value = Math.min(Math.max(rawPercentage, 0), 100);
  };

  // Progress within the current section
  // Example: { current: 3, total: 5 } means the user has completed 3 out of 5 steps (questions) in the current section.
  const setCurrentSectionProgress = (progress) => {
    current_section_progress.value = progress?.current_section_progress || null;
  };

  const setVisibility = (progress) => {
    visible.value = progress?.visible || false;
  };

  const reset = () => {
    progress_percentage.value = 0;
    current_section_progress.value = null;
    visible.value = false;
  };

  return {
    progress_percentage,
    current_section_progress,
    visible,
    setProgressPercentage,
    setCurrentSectionProgress,
    setVisibility,
    reset,
  };
});
